// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project

// CONSTANTS
export const INIT = 'INIT';

// ACTIONS
export function initApp() {
  return {
    type: INIT
  };
}